import React from "react";
import { Box } from "@cloudscape-design/components";
import Card from "../../common/Card/Card";
import Button from "../../common/Button";
import Badge from "../../common/Badge";
import { ActivityItem } from "../types";
import "./activity-list-item.scss";

interface ActivityListItemProps {
  activity: ActivityItem;
  onView?: (activity: ActivityItem) => void;
  onDownload?: (activity: ActivityItem) => void;
  onDelete?: (activity: ActivityItem) => void;
}

const ActivityListItem: React.FC<ActivityListItemProps> = ({
  activity,
  onView,
  onDownload,
  onDelete,
}) => {
  const getStatusBadgeColor = (status: string) => {
    switch (status) {
      case 'Completed':
        return 'green';
      case 'In Progress':
        return 'blue';
      case 'Failed':
        return 'red';
      default:
        return 'grey';
    }
  };

  return (
    <Card 
      width="100%" 
      height="auto" 
      className="activity-list-item"
    >
      <div className="activity-content">
        {/* Main content area */}
        <div className="activity-main">
          <div className="activity-header">
            <div className="activity-info">
              <h3 className="activity-title">{activity.reportName}</h3>
              {activity.description && (
                <p className="activity-description">{activity.description}</p>
              )}
            </div>
          </div>
          
          {/* Badges with timestamp, and actions in one row */}
          <div className="activity-bottom-row">
            <div className="activity-badges-with-timestamp">
              <div className="activity-badges">
                <Badge variant="category" color="blue">
                  {activity.category}
                </Badge>
                <Badge variant="status" color={getStatusBadgeColor(activity.status)}>
                  {activity.status}
                </Badge>
              </div>
              <div className="activity-timestamp">
                <Box variant="small" color="text-body-secondary">
                  {activity.date}
                </Box>
              </div>
            </div>
            <div className="activity-actions">
              <Button
                variant="primary"
                icon="external"
                onClick={() => onView?.(activity)}
              >
                View
              </Button>
              
              {activity.downloadUrl && (
                <Button
                  variant="secondary"
                  icon="download"
                  onClick={() => onDownload?.(activity)}
                >
                  Download
                </Button>
              )}
              
              <Button
                variant="secondary"
                icon="remove"
                onClick={() => onDelete?.(activity)}
                className="activity-delete-button"
              >
                Delete
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default ActivityListItem;
